import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, certapplyActions } from '../../../../../store/actions'
import moment from 'moment'
import Input from '../../../../../module/input'
import Calendar from '../../../../../module/component-box/Calendar'
import { commons } from '../../../../../hook/common'
import $ from 'jquery'

/**
 * 물품 등록/수정 팝업
 * @param props
 * @constructor
 */
const PopGoods = (props) => {
  const nodeBaseInfo = {
    itemCd: {
      title: '제품코드',
      type: 'text',
      length: 6,
    },
    hsCd: {
      title: 'HS부호',
      type: 'text',
      length: 10,
      required: true,
      message: 'HS부호를 입력해주세요.',
    },
    itemnm: {
      title: '품명',
      type: 'text',
      length: 35,
      required: true,
      message: '품명을 입력해주세요.',
    },
    companymngcd: {
      title: '자산관리코드',
      type: 'text',
      length: 10,
    },
    itemdeftxt: {
      title: '규격',
      type: 'text',
      length: 70,
    },
    notetxt: {
      title: '비고',
      type: 'text',
      length: 70,
    },
    baseAmt: {
      title: '단가',
      type: 'number',
      required: true,
      message: '단가를 입력해주세요.',
      withInput: 'KRW',
    },
    baseCnt: {
      title: '단위수량',
      type: 'number',
      required: true,
      message: '단위수량을 입력해주세요.',
    },
    grcnt: {
      title: '총수량',
      type: 'number',
      required: true,
      message: '총수량을 입력해주세요.',
      length: 10,
      className: 'right',
    },
    gramt: {
      title: '총금액',
      type: 'number',
      required: true,
      readOnly: true,
      message: '총금액을 입력해주세요.',
    },
    crtYmd: {
      title: '구매일자',
    },
  }

  const inputRef = React.useRef(new Array(Object.keys(nodeBaseInfo).length))
  const [state, setState] = useState({})
  const [nodeInfo, setNodeInfo] = useState(nodeBaseInfo)
  const [reset, setReset] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editIdx, setEditIdx] = useState(-1)
  const [itemList, setItemList] = useState(props.stepData)
  const [itemInput, setItemInput] = useState({})
  const [selectItems, setSelectItems] = useState([])

  /**
   * 화면집입시 초기값 세팅
   */
  useEffect(() => {
    let list = JSON.parse(sessionStorage.getItem(props.docid)).step2
    commons.preventKeyDown()
    setItemList(list)
  }, [])
  /**
   * 데이터 저장 후 입력폼 갱신
   */
  useEffect(() => {
    if (props.isCalled === true && !props.isFailure) {
      setItemList(props?.stepData)
      setReset(true)
      newInput()
    }
    props.setCalled(false)
  }, [props?.isCalled])

  /**
   * input 갱신을 위한 hook
   */
  useEffect(() => {
    if (reset === true) setReset(false)
  }, [reset])

  /**
   * 입력학목 유효성 체크 및 저장 api 호출
   */
  const saveItem = () => {
    setState({ ...state, submitted: !state.submitted, errCrtYmd: '' })

    let node = nodeInfo
    let errCnt = 0
    let isFocus = false

    Object.keys(node).forEach((key, index) => {
      let message = null

      //필수 체크
      if (node[key].required) {
        if (!itemInput?.[key] || itemInput?.[key]?.length <= 0) {
          message = node[key]?.message
          errCnt++
        }
      }

      node[key].errMessage = message

      if (!isFocus && errCnt === 1) {
        isFocus = true
        inputRef.current[index].focus()
      }
    })

    if (!itemInput.crtYmd || itemInput.crtYmd?.length <= 0) {
      setState({ ...state, errCrtYmd: '구매일자를 선택해주세요.' })
      errCnt++
    }

    if (errCnt > 0) return

    itemInput.totamtcur = props.currency
    props.saveStep(props.docid, '2', itemInput, isEdit)
  }

  /**
   * 물품정보 수정
   * @param seq
   */
  const selectEdit = (crtItemSeq, index = -1) => {
    if (editIdx === index) {
      newInput()
    } else {
      setItemInput({ ...itemList[itemList.findIndex((item) => item.crtItemSeq === crtItemSeq)] })
      setIsEdit(true)
      setEditIdx(index)
    }
  }

  /**
   * 새로작성
   */
  const newInput = () => {
    setState({ ...state, errCrtYmd: '' })
    let node = nodeInfo
    Object.keys(node).forEach((key, index) => {
      node[key].errMessage = null
    })
    // 체크박스 초기화
    setSelectItems([])
    $('input:checkbox').each((index, value) => {
      value.checked = false
    })

    setItemInput({
      gramt: 0,
    })
    setIsEdit(false)
    setEditIdx(-1)
    setReset(true)
  }

  /**
   * 선택삭제
   * @returns {*}
   */
  const deleteItems = () => {
    if (selectItems?.length <= 0) {
      return props.error({ message: '삭제할 물품을 선택해주세요.' })
    }

    props.confirm({
      title: '확인',
      message: '정말 삭제하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          props.deleteStepItems(props.docid, '2', selectItems)
        },
      },
    })
  }

  /**
   * 전체삭제
   */
  const deleteAll = () => {
    itemList?.length > 0 &&
      props.confirm({
        title: '확인',
        message: '정말 삭제하시겠습니까?',
        params: {
          type: 'confirm',
          callback: () => {
            props.deleteStepItemAll(props.docid, '2')
          },
        },
      })
  }

  const handleClose = () => {
    props.onClose()
  }

  const handleChange = (e) => {
    const { name, value } = e.target

    let obj = {
      ...itemInput,
      [name]: value,
    }
    if (name === 'baseAmt') {
      obj.gramt = parseInt(value) * parseInt(obj.grcnt)
    }

    if (name === 'grcnt') {
      obj.gramt = parseInt(value) * parseInt(obj.baseAmt)
    }
    setItemInput(obj)
  }

  const onSelectItem = (e) => {
    const { name, checked } = e.target
    let list = selectItems
    if (checked) {
      list.push(name)
    } else {
      list = selectItems.filter((item) => item !== name)
    }
    setSelectItems(list)
  }

  const generateInput = (key) => {
    const node = nodeInfo[key]
    let idx = Object.keys(nodeBaseInfo).findIndex((objKey) => objKey === key)
    let className = ''
    let wrapperClassName = node?.wrapperClassName
    let maxLength = node.length
    !maxLength && node?.type === 'number' && (className += 'right ')
    !maxLength && node?.type === 'number' && (maxLength = 16)

    return (
      <Input
        id={key}
        name={key}
        type={node.type}
        inputTitle={node?.inputTitle ? node?.inputTitle : node?.title}
        value={key === 'gramt' ? (itemInput?.[key] === 0 ? 0 : itemInput?.[key] || '') : itemInput?.[key] || ''}
        ref={(ref) => (inputRef.current[idx] = ref)}
        wrapperClassName={wrapperClassName}
        className={className + node?.className}
        placeholder={node?.placeholder}
        message={node?.message}
        onChange={handleChange}
        readOnly={node.readOnly}
        required={node.required}
        flow={node.flow ? node.flow : `${window.innerWidth >= 767 ? 'left' : 'up'}`}
        length={maxLength}
        errMessage={node.errMessage}
      />
    )
  }

  let style = {
    backgroundColor: 'rgb(0, 0, 0)',
    position: 'fixed',
    inset: '0px',
    opacity: '0.6',
    zIndex: '1',
  }

  let styleModal = {
    position: 'absolute',
    opacity: '1',
    zIndex: '2',
    display: 'block',
  }

  return (
    <React.Fragment>
      {/* 구매물품 목록 등록/수정 */}
      <div style={style}></div>
      <div style={styleModal} id="purchase-register" className="modal w1120">
        <div className="modal-head">
          <h2>구매 물품 목록 등록</h2>
        </div>
        <div className="modal-cont">
          <table className="tbl-write">
            <caption>HS부호, 품명, 자산관리코드, 규격, 단가, 단위수량, 수량, 총 금액, 구매일자, 비고 항목으로 구성</caption>
            <colgroup>
              <col className="col1" />
              <col className="col2" />
              <col className="col1" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  <em className="required" /> HS부호
                </th>
                <td>{generateInput('hsCd')}</td>
                <th scope="row">
                  <em className="required" /> 품명
                </th>
                <td>{generateInput('itemnm')}</td>
              </tr>
              <tr>
                <th scope="row">자산관리코드</th>
                <td>{generateInput('companymngcd')}</td>
                <th scope="row">규격</th>
                <td>{generateInput('itemdeftxt')}</td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" />
                  단가
                </th>
                <td>
                  <span className="input-group full">
                    <span className="txt">{props.currency}</span>
                    {generateInput('baseAmt')}
                  </span>
                </td>
                <th scope="row">
                  <em className="required" /> 단위수량
                </th>
                <td>
                  <span className="input-group full">
                    {generateInput('baseCnt')}
                    <span className="txt">개</span>
                  </span>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 수량
                </th>
                <td>
                  <span className="input-group full right">
                    {generateInput('grcnt')}
                    <span className="txt">개</span>
                  </span>
                </td>
                <th scope="row">
                  <em className="required" /> 총 금액
                </th>
                <td>
                  <span className="input-group full">
                    <span className="txt">{props.currency}</span>
                    {generateInput('gramt')}
                  </span>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 구매일자
                </th>
                <td>
                  {reset === false && (
                    <span className="datepicker">
                      <Calendar
                        default={itemInput.crtYmd && moment(itemInput.crtYmd, 'YYYYMMDD').format('YYYY-MM-DD')}
                        onSelect={(value) =>
                          setItemInput({
                            ...itemInput,
                            crtYmd: moment(value).format('YYYYMMDD'),
                          })
                        }
                      />
                    </span>
                  )}
                  {state.errCrtYmd && <span className="txt">{state.errCrtYmd}</span>}
                </td>
                <th scope="row">비고</th>
                <td>{generateInput('notetxt')}</td>
              </tr>
            </tbody>
          </table>
          <div className="btn-block center">
            <a
              href="#"
              className="btn-secondary md"
              onClick={(e) => {
                e.preventDefault()
                newInput()
              }}
            >
              새로작성
            </a>
            <a
              href="#"
              className="btn-primary md"
              onClick={(e) => {
                e.preventDefault()
                saveItem()
              }}
            >
              {isEdit === true ? '수정' : '저장'}
            </a>
          </div>

          <div className="list-header">
            <span className="total-num">총 {itemList?.length}건</span>
            <span className="right">
              <a
                href="#"
                className="btn-secondary sm"
                onClick={(e) => {
                  e.preventDefault()
                  deleteItems()
                }}
              >
                선택삭제
              </a>
              <a
                href="#"
                className="btn-secondary sm"
                onClick={(e) => {
                  e.preventDefault()
                  deleteAll()
                }}
              >
                전체삭제
              </a>
            </span>
          </div>
          <div className="tbl-wrap">
            <table className="tbl-list" id="checkboxTable">
              <caption>선택, HS부호, 품명, 규격, 수량, 구매일, 단가, 금액 항목으로 구성</caption>
              <colgroup>
                <col style={{ width: '7%' }} />
                <col style={{ width: '13%' }} />
                <col style={{ width: '22%' }} />
                <col style={{ width: '11%' }} />
                <col style={{ width: '11%' }} />
                <col style={{ width: '13%' }} />
                <col style={{ width: '11%' }} />
                <col />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">선택</th>
                  <th scope="col">HS부호</th>
                  <th scope="col">품명</th>
                  <th scope="col">규격</th>
                  <th scope="col">수량</th>
                  <th scope="col">구매일</th>
                  <th scope="col">
                    단가
                    <br />({props.currency})
                  </th>
                  <th scope="col">
                    금액
                    <br />({props.currency})
                  </th>
                </tr>
              </thead>
              <tbody>
                {itemList?.length > 0 ? (
                  itemList.map((item, index) => {
                    return (
                      <tr className={'row ' + (isEdit && editIdx === index ? 'active' : '')} key={index}>
                        <td>
                          <input title={'checkbox' + index} type="checkbox" name={item.crtItemSeq} onChange={onSelectItem} />
                          <em />
                        </td>
                        <td data-title={'HS부호'} onClick={() => selectEdit(item.crtItemSeq, index)}>
                          {item.hsCd}
                        </td>
                        <td data-title={'품명'} onClick={() => selectEdit(item.crtItemSeq, index)}>
                          {item.itemnm}
                        </td>
                        <td data-title={'규격'} onClick={() => selectEdit(item.crtItemSeq, index)}>
                          {item.itemdeftxt}
                        </td>
                        <td data-title={'수량'} onClick={() => selectEdit(item.crtItemSeq, index)}>
                          {commons.addComma(item.grcnt)}
                        </td>
                        <td data-title={'구매일'}>{moment(item.crtYmd).format('YYYY-MM-DD')}</td>
                        <td data-title={'단가'}>{commons.addComma(item.baseAmt)}</td>
                        <td data-title={'금액'}>{commons.addComma(item.gramt)}</td>
                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td colSpan={8}>
                      <div className="nodata">등록된 자료가 없습니다.</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <button type="button" className="modal-close b-close" onClick={handleClose}>
          창닫기
        </button>
      </div>
      {/* 구매물품 목록 등록/수정 */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    stepData: state.certapply?.data?.step2,
    isCalled: state.certapply.isCalled,
    isFailure: state.certapply.isFailure,
  }
}

const actionCreators = {
  saveStep: certapplyActions.saveStep,
  setCalled: certapplyActions.setCalled,
  error: alertActions.error,
  confirm: alertActions.confirm,
  deleteStepItems: certapplyActions.deleteStepItems,
  deleteStepItemAll: certapplyActions.deleteStepItemAll,
}

export default connect(mapStateToProps, actionCreators)(PopGoods)
